var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRecur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.919 0 0 2.919 0 6.5C0 10.0815 2.919 13 6.5 13C9.7775 13 12.5 10.556 12.9375 7.3905C12.956 7.29072 12.9541 7.18822 12.9318 7.08921C12.9095 6.9902 12.8674 6.89674 12.8079 6.81449C12.7485 6.73223 12.673 6.6629 12.586 6.61069C12.4989 6.55847 12.4022 6.52446 12.3017 6.51071C12.2011 6.49696 12.0988 6.50376 12.001 6.53069C11.9032 6.55763 11.8118 6.60414 11.7325 6.66742C11.6531 6.73069 11.5874 6.80941 11.5394 6.8988C11.4914 6.9882 11.462 7.08641 11.453 7.1875C11.1165 9.6225 9.0355 11.5 6.5 11.5C3.73 11.5 1.5 9.2705 1.5 6.5C1.5 3.73 3.73 1.5 6.5 1.5C8.118 1.5 9.5545 2.2675 10.469 3.453L9.578 4.344C9.503 4.419 9.4835 4.5395 9.5155 4.6405C9.5455 4.7415 9.63 4.8065 9.7345 4.828C11.083 5.093 12.638 4.976 12.703 4.9685C12.7689 4.95663 12.8292 4.92384 12.875 4.875C12.92 4.831 12.96 4.785 12.969 4.7185C12.9765 4.6535 13.094 3.085 12.828 1.7345C12.8201 1.68422 12.7984 1.63713 12.7652 1.59846C12.7321 1.55979 12.689 1.53108 12.6405 1.5155C12.5385 1.4845 12.4185 1.503 12.344 1.578L11.5315 2.3905C10.339 0.935 8.5235 0 6.5 0Z",
    fill: "#6DA544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRecur);
export default __webpack_public_path__ + "static/media/ic_recur.13dcb00f64da69466aa0ad6cf105cd08.svg";
export { ForwardRef as ReactComponent };